module.exports = "/static/media/tablet.6ec6fb41.svg";